import type { GetSmModelsParams, SmModelsResponse } from '@/types/catalog'
import * as apiBff from './bff'

export async function getSmModels({
  season,
  superModelId,
  page = 0,
  pageSize = 8,
}: GetSmModelsParams): Promise<SmModelsResponse> {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
  })

  return apiBff.callBFF<SmModelsResponse>(
    'GET',
    `season/${season}/super-models/${superModelId}/models?${params.toString()}`,
  )
}
